export const actionTypes = {
  STAFF: 'staff',
  CLIENT: 'client',
  FORGOT: 'forgot',
};
